import { Observable } from 'rxjs';

import { Billing } from '../models/usage.model';

export abstract class UsageGateway {
  abstract getBilling(year: number, month: number): Observable<Billing>;
}
